<script>
import BAutocomplete from './BAutocomplete.vue'

export default {
  name: 'BAutocompleteList',
  extends: BAutocomplete,
  methods: {
    onClear() {},
  },
}
</script>
